<template>
  <div class="cash_wrap" >
    <div class="cash_block" >
      <div class="cash_block_title" >
        <div>奖励金金额（元）</div>
        <div @click="chargeList" >明细</div>
      </div>
      <div class="cash_block_money" >
        <span>￥</span>
        <span>{{ userMoneyVo.allMoney }}</span>
      </div>
      <div class="cash_block_title" >
        <div>可提现金额：{{ userMoneyVo.canCashOutMoney }}</div>
        <div>未结算：{{ userMoneyVo.sumSoonShareMoney }}</div>
      </div>
    </div>


    <van-form @submit="onSubmit" >
<!--      <div class="cash_card" v-if="currentDate === middleDate || currentDate === lastDate" >
        <div class="cash_title" >提现金额</div>
        <div class="cash_money_input" >
          <div>￥</div>
          <van-field :placeholder="`最低提现金额${serviceCharge.minDrawMoney}元`" type="number" class="money_input" name="drawMoney" v-model="drawMoney"
                     :rules="[{ required: true, message: '' }]"
          />
        </div>
        <div class="service_charge_wrap" >
          <div :style="{ visibility: drawMoney ? '': 'hidden' }" >手续费：￥{{ (parseFloat(serviceCharge.fixedMoney)+parseFloat(drawMoney)*(serviceCharge.freMoney/100)).toFixed(2) }}</div>
          <div @click="cashAll" > 全部提现</div>
        </div>
      </div>-->

      <div class="cash_card">
        <div class="cash_form_item" >
          <div class="cash_form_item_label" >提现金额</div>
          <van-field placeholder="请输入提现金额" name="drawMoney" class="form_item_input" v-model="drawMoney"   :rules="[{ required: true, message: '' }]" />
        </div>
      </div>
<!--      <template v-if="!update" >
        <template>
          <div class="cash_card">
            <div class="cash_title" >基本信息</div>
            <div class="cash_form_item" >
              <div class="cash_form_item_label" >支付类型</div>
              <van-field value="银行卡转账" class="form_item_input" readonly />
            </div>

            <div class="cash_form_item" >
              <div class="cash_form_item_label" >姓名</div>
              <van-field placeholder="请输入姓名" class="form_item_input" name="cardUserName"  v-model="cardUserName"
                         :rules="[{ required: true, message: '' }]"
              />
            </div>

            <div class="cash_form_item" >
              <div class="cash_form_item_label" >身份证</div>
              <van-field placeholder="请输入身份证号" class="form_item_input" name="IDCardNo" v-model="IDCardNo"
                         :rules="[{ required: true, message: '' }]"
              />
            </div>

            <div class="cash_form_item" >
              <div class="cash_form_item_label" >手机号</div>
              <van-field placeholder="请输入手机号" class="form_item_input" v-model="userVo.tel" disabled
                         :rules="[{ required: true, message: '' }]"
              />
            </div>

            <div class="cash_form_item" >
              <div class="cash_form_item_label" >验证码</div>
              <van-field placeholder="请输入验证码" class="form_item_input" type="number" :maxlength="6" name="verificationCode" v-model="verificationCode"
                         :rules="[{ required: true, message: '' }]"
              >
                <template #button>
                  <div class="code_btn" @click="getCode" >
                    {{ seconds > 0 ? `${seconds}秒后重新发送` : '发送验证码' }}
                  </div>
                </template>
              </van-field>
            </div>
          </div>

          <div class="cash_card">
            <div class="cash_title" >银行卡信息</div>
            <div class="cash_form_item" >
              <div class="cash_form_item_label" >所属银行</div>
              <van-field placeholder="请选择所属银行" class="form_item_input" readonly @click="showBank = true" v-model="bankName" name="bankId"
                         :rules="[{ required: true, message: '' }]"
              >
                <template #button>
                  <div class="down" :class="rotate" ></div>
                </template>
              </van-field>
            </div>
            <van-popup v-model="showBank" position="bottom" >
              <van-picker
                title="选择所属银行"
                show-toolbar
                :columns="wxBankList"
                value-key="name"
                @confirm="bankConfirm"
                @cancel="showBank = false"
              />
            </van-popup>

            <div class="cash_form_item" >
              <div class="cash_form_item_label" >银行卡号</div>
              <van-field placeholder="请输入银行卡号" class="form_item_input" name="cardNum" type="number" v-model="cardNum"
                         :rules="[{ required: true, message: '' }]"
              />
            </div>

            <div class="cash_form_item" >
              <div class="cash_form_item_label" >所属支行</div>
              <van-field placeholder="请输入所属支行" class="form_item_input" name="branchName" v-model="branchName"
                         :rules="[{ required: true, message: '' }]"
              />
            </div>
          </div>
        </template>
      </template>

      <template v-else >
        <div class="cash_card cash_bank" v-if="currentDate === middleDate || currentDate === lastDate" >
          <div class="cash_title" >提现到</div>
          <div class="cash_money_input" >
            <van-field readonly type="number" class="money_input" :value="userMoneyVo.h5UserMoneyBankVo.bankName+'('+userMoneyVo.h5UserMoneyBankVo.cardNum.substring(userMoneyVo.h5UserMoneyBankVo.cardNum.length - 4, userMoneyVo.h5UserMoneyBankVo.cardNum.length)+')'"
                       :rules="[{ required: true, message: '' }]"
            />
          </div>
          <div class="update_text" @click="update = false" >修改信息</div>
        </div>
      </template>-->


      <div class="cash_rules_wrap" >
        <div class="cash_rules_title" >
          <div class="cash_icon" ></div>
          提现规则
        </div>
<!--        <div class="cash_rules_desc" >
          <div>1.系统自动默认15天结算周期，结算后即可申请提现或者消费。</div>
          <div>2.提现收取6‰手续费。</div>
          <div>3.已结算收益满50元即可提现。</div>
          <div>4.每月可在15号与30号发起两次提现申请。</div>
          <div>5.到账时间：T+3</div>
        </div>-->
        <div class="cash_rules_desc" >
          <div>1.系统自动默认7天结算周期，结算后即可申请提现或者消费。</div>
          <div>2.提现收取{{ serviceCharge.freMoney }} %手续费。</div>
          <div>3.提现 {{ serviceCharge.minDrawMoney }} 元起提。</div>
          <div>4.每月 1 号以后随时可提现。</div>
          <div>5.到账时间：T+1</div>
        </div>
      </div>
      <van-button class="cash_apply_btn" type="info" native-type="submit" :loading="submitting" >申请提现</van-button>
    </van-form>


  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import { getUserMoneyVo, getWxBankList, getUserMoneyCashOutServiceCharge, addDrawMoney, addDrawMoneyByLastDrawInfo, sendDrawMoneyVerificationCode } from '@/api/account'
import { Toast } from "vant";
import moment from 'moment'

export default {
  name: 'cashApply',
  data() {
    return {
      payTypeStr: '银行卡转账',
      rotate: 'right',
      showBank: false,
      userMoneyVo: {
        allMoney: 0,
        canCashOutMoney: 0,
        sumSoonShareMoney: 0,
        h5UserMoneyBankVo: {
        }
      },
      wxBankList: [],
      serviceCharge: {
        fixedMoney: 0,
        freMoney: 0,
        minDrawMoney: 0
      },
      drawMoney: '',
      bankId: '',
      cardNum: '',
      cardUserName: '',
      tel: '',
      IDCardNo: '',
      branchName: '',
      bankName: '',
      submitting: false,
      id: '',
      timer: null,
      seconds: 0,
      verificationCode: '',
      userVo: JSON.parse(localStorage.getItem('userVo')),
      moment,
      currentDate: '',
      middleDate: '',
      lastDate: '',
      update: false
    }
  },
  watch: {
    showBank(val) {
      val ?  this.rotate = 'rotate_down' : this.rotate = 'right'
    }
  },
  methods: {
    getCode() {
      if(this.seconds > 0) {
        return false
      }
      sendDrawMoneyVerificationCode({}).then(res => {
        if(res.success) {
          this.seconds = 60
          this.timer = setInterval(() => {
            this.seconds --;
            if(this.seconds <= 0) {
              clearInterval(this.timer)
            }
          }, 1000)
        }else {
          Toast(res.msg)
        }
      })
    },
    cashAll() {
      if(parseFloat(this.userMoneyVo.canCashOutMoney) <= 0) {
        Toast('可提现金额不足')
        return false
      }
      this.drawMoney = this.userMoneyVo.canCashOutMoney
    },
    onSubmit(values) {
    /*  if(this.update){
        this.cashMoney(values)
      }else {
        this.cashByBank(values)
      }*/
      if(parseFloat(values.drawMoney) > parseFloat(this.userMoneyVo.canCashOutMoney)) {
        Toast('提现金额不得大于可提现金额')
        return false
      }
      addDrawMoney({...values}).then(res => {
        if(res.success) {
          Toast('操作成功')
          this.$router.go(-1)
        }else {
          Toast(res.msg)
        }
      })
    },
    cashMoney(values) {
      delete values['undefined']
      this.submitting = true
      values.drawMoney = this.userMoneyVo.canCashOutMoney
      addDrawMoneyByLastDrawInfo({...values}).then(res => {
        this.submitting = false
        if(res.success) {
          Toast('操作成功')
          this.$router.go(-1)
        }else {
          Toast(res.msg)
        }
      })
    },
    cashByBank(values) {
      delete values['undefined']
      values.bankId = this.id
      values.drawMoney = this.userMoneyVo.canCashOutMoney
      this.submitting = true
      addDrawMoney({...values}).then(res => {
        this.submitting = false
        if(res.success) {
          Toast('操作成功')
          this.$router.go(-1)
        }else {
          Toast(res.msg)
        }
      })
    },
    chargeList() {
      this.$router.push({ name: 'chargeList' })
    },
    bankConfirm(value, index) {
      this.id = value.bankId
      this.bankName = value.name
      this.showBank = false
    },
    getUserMoneyVo() {
      getUserMoneyVo({}).then(res => {
        if(res.success) {
          this.userMoneyVo = res.data
          console.log('userMoneyVo:', this.userMoneyVo)
          // if(this.userMoneyVo.h5UserMoneyBankVo) {
          //   this.update = true
          // }
        }
      })
    },
    getWxBankList() {
      getWxBankList({}).then(res => {
        console.log(res)
        if(res.success) {
          this.wxBankList = res.data
        }
      })
    },
    getUserMoneyCashOutServiceCharge() {
      getUserMoneyCashOutServiceCharge({}).then(res => {
        if(res.success) {
          this.serviceCharge = res.data
        }
      })
    }
  },
  mounted() {
    this.getUserMoneyVo()
    this.getWxBankList()
    this.getUserMoneyCashOutServiceCharge()
    this.currentDate = moment(new Date()).format('YYYY-MM-DD')
    this.middleDate = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 15)).format('YYYY-MM-DD')
    this.lastDate = new Date().getMonth()+1 === 2 ? moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('YYYY-MM-DD') : moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, -1)).format('YYYY-MM-DD');
  }
}
</script>
